<ng-container [formGroup]="form">
  <app-table-header-column name="number" size="medium">
    <span content>
      Nº
      <app-filter-button
        [column]="'no'"
        [menu]="numberFilterMenu"
        [appliedFilters]="appliedFilters"
        [sortColumn]="sortColumn"
        #numberFilterBtn>
      </app-filter-button>
    </span>
  </app-table-header-column>

  <mat-menu #numberFilterMenu="matMenu">
    <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <h4>Filtrar por número da ordem</h4>
      <button (click)="sort('no', 'DESC')" mat-menu-item>
        Ordem decrescente
        <i class="uil uil-check" *ngIf="showCheckIcon['no'] && sortDirection == 'DESC'"></i>
      </button>
      <button (click)="sort('no', 'ASC')" mat-menu-item>
        Ordem crescente
        <i class="uil uil-check" *ngIf="showCheckIcon['no'] && sortDirection == 'ASC'"></i>
      </button>
      <mat-form-field appearance="outline">
        <input matInput placeholder="Número da Ordem" formControlName="no" autocomplete="off">
      </mat-form-field>
        <section class="actions">
          <button mat-stroked-button class="gray-1" (click)="clearFilters(numberFilterBtn.menuTrigger, 'no')">
            Limpar
          </button>
          <button mat-raised-button class="primary-1" (click)="applyFilters(numberFilterBtn.menuTrigger)">
            Salvar
          </button>
        </section>
    </div>
  </mat-menu>

  <app-table-header-column name="receivedAt" size="small">
    <span content>
      Data/Hora de Entrada
      <app-filter-button
        [column]="'date'"
        [menu]="dateFilterMenu"
        [appliedFilters]="appliedFilters"
        [sortColumn]="sortColumn"
        #dateFilterBtn>
      </app-filter-button>
    </span>
  </app-table-header-column>

  <mat-menu #dateFilterMenu="matMenu">
    <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <h4>Filtrar por data de entrada</h4>
      <button (click)="sort('date', 'DESC')" mat-menu-item>
        Ordem decrescente
        <i class="uil uil-check" *ngIf="showCheckIcon['date'] && sortDirection == 'DESC'"></i>
      </button>
      <button (click)="sort('date', 'ASC')" mat-menu-item>
        Ordem crescente
        <i class="uil uil-check" *ngIf="showCheckIcon['date'] && sortDirection == 'ASC'"></i>
      </button>
      <mat-form-field appearance="outline">
        <mat-label>Data inicial</mat-label>
        <input matInput [matDatepicker]="startDatePicker" formControlName="startDate" required [max]="maxDate" [disabled]="true"
          (dateChange)="ondateStartDateChange()">
        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker [disabled]="false"></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Data final</mat-label>
        <input matInput [matDatepicker]="endDatePicker" formControlName="endDate"
          required [max]="maxDate" [min]="minDate" [disabled]="true" (dateChange)="ondateEndDateChange()"
        >
        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker [disabled]="false"></mat-datepicker>
      </mat-form-field>
        <section class="actions">
          <button mat-stroked-button class="gray-1" (click)="clearFilters(dateFilterBtn.menuTrigger, 'date')">
            Limpar
          </button>
          <button mat-raised-button class="primary-1" (click)="applyFilters(dateFilterBtn.menuTrigger)"
            [disabled]="isdateSaveBtnDisabled">
            Salvar
          </button>
        </section>
    </div>
  </mat-menu>

  <app-table-header-column name="exitAt" size="small">
    <span content>
      Data/Hora de Saída
      <app-filter-button
        [column]="'outOrderEventHistoryDispatchedAt'"
        [menu]="outOrderEventHistoryDispatchedAtFilterMenu"
        [appliedFilters]="appliedFilters"
        [sortColumn]="sortColumn"
        #outOrderEventHistoryDispatchedAtFilterBtn>
      </app-filter-button>
    </span>
  </app-table-header-column>

  <mat-menu #outOrderEventHistoryDispatchedAtFilterMenu="matMenu">
    <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <h4>Ordenar por última movimentação</h4>
      <button (click)="sort('outOrderEventHistoryDispatchedAt', 'DESC')" mat-menu-item>
        Ordem decrescente
        <i class="uil uil-check" *ngIf="showCheckIcon['outOrderEventHistoryDispatchedAt'] && sortDirection == 'DESC'"></i>
      </button>
      <button (click)="sort('outOrderEventHistoryDispatchedAt', 'ASC')" mat-menu-item>
        Ordem crescente
        <i class="uil uil-check" *ngIf="showCheckIcon['outOrderEventHistoryDispatchedAt'] && sortDirection == 'ASC'"></i>
      </button>
      <mat-form-field appearance="outline">
        <mat-label>Data inicial</mat-label>
        <input matInput [matDatepicker]="outOrderEventHistoryDispatchedAtStartDatepicker" formControlName="outOrderEventHistoryDispatchedAtStartDate"
          required [max]="outOrderEventHistoryDispatchedAtMaxDate" [disabled]="true" (dateChange)="onOutOrderDispatchedAtStartDateChange()">
        <mat-datepicker-toggle matSuffix [for]="outOrderEventHistoryDispatchedAtStartDatepicker"></mat-datepicker-toggle>
        <mat-datepicker #outOrderEventHistoryDispatchedAtStartDatepicker [disabled]="false"></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Data final</mat-label>
        <input matInput [matDatepicker]="outOrderEventHistoryDispatchedAtEndDatepicker" formControlName="outOrderEventHistoryDispatchedAtEndDate"
          required [max]="outOrderEventHistoryDispatchedAtMaxDate" [min]="outOrderEventHistoryDispatchedAtMinDate" [disabled]="true" (dateChange)="onOutOrderDispatchedAtEndDateChange()"
        >
        <mat-datepicker-toggle matSuffix [for]="outOrderEventHistoryDispatchedAtEndDatepicker"></mat-datepicker-toggle>
        <mat-datepicker #outOrderEventHistoryDispatchedAtEndDatepicker [disabled]="false"></mat-datepicker>
      </mat-form-field>
      <section class="actions">
        <button mat-stroked-button class="gray-1" (click)="clearFilters(outOrderEventHistoryDispatchedAtFilterBtn.menuTrigger, 'outOrderEventHistoryDispatchedAt')">
          Limpar
        </button>
        <button mat-raised-button class="primary-1" (click)="applyFilters(outOrderEventHistoryDispatchedAtFilterBtn.menuTrigger)"
          [disabled]="isoutOrderEventHistoryDispatchedAtSaveBtnDisabled">
          Salvar
        </button>
      </section>
    </div>
  </mat-menu>

  <app-table-header-column name="description" size="medium">
    <span content>
      Produtos
      <app-filter-button
        [column]="'productName'"
        [menu]="productsFilterMenu"
        [appliedFilters]="appliedFilters"
        [sortColumn]="sortColumn"
        #productFilterBtn>
      </app-filter-button>
    </span>
  </app-table-header-column>

  <mat-menu #productsFilterMenu="matMenu">
    <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <h4>Filtrar por produtos</h4>
      <button (click)="sort('productName', 'DESC')" mat-menu-item>
        Ordem decrescente
        <i class="uil uil-check" *ngIf="showCheckIcon['productName'] && sortDirection == 'DESC'"></i>
      </button>
      <button (click)="sort('productName', 'ASC')" mat-menu-item>
        Ordem crescente
        <i class="uil uil-check" *ngIf="showCheckIcon['productName'] && sortDirection == 'ASC'"></i>
      </button>
        <mat-form-field appearance="outline">
          <input matInput placeholder="Produtos" formControlName="productName" autocomplete="off">
        </mat-form-field>
        <section class="actions">
          <button mat-stroked-button class="gray-1" (click)="clearFilters(productFilterBtn.menuTrigger, 'productName')">
            Limpar
          </button>
          <button mat-raised-button class="primary-1" (click)="applyFilters(productFilterBtn.menuTrigger)">Salvar</button>
        </section>
    </div>
  </mat-menu>

  <app-table-header-column name="totalQuantity" size="qtd" alignRight="true">
    <span content>
      Qtd
      <app-filter-button
        [column]="'totalQuantity'"
        [menu]="totalQuantityFilterMenu"
        [appliedFilters]="appliedFilters"
        [sortColumn]="sortColumn"
        #totalQuantityFilterBtn>
      </app-filter-button>
    </span>
  </app-table-header-column>

  <mat-menu #totalQuantityFilterMenu="matMenu">
    <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <h4>Filtrar por quantidade</h4>
      <button (click)="sort('totalQuantity', 'DESC')" mat-menu-item>
        Ordem decrescente
        <i class="uil uil-check" *ngIf="showCheckIcon['totalQuantity'] && sortDirection == 'DESC'"></i>
      </button>
      <button (click)="sort('totalQuantity', 'ASC')" mat-menu-item>
        Ordem crescente
        <i class="uil uil-check" *ngIf="showCheckIcon['totalQuantity'] && sortDirection == 'ASC'"></i>
      </button>
      <mat-form-field appearance="outline">
        <input matInput placeholder="Quantidade" type="number" formControlName="totalQuantity" min="1" autocomplete="off">
      </mat-form-field>
      <section class="actions">
        <button mat-stroked-button class="gray-1"
          (click)="clearFilters(totalQuantityFilterBtn.menuTrigger, 'totalQuantity')">
          Limpar
        </button>
        <button mat-raised-button class="primary-1" (click)="applyFilters(totalQuantityFilterBtn.menuTrigger)">Salvar</button>
      </section>
    </div>
  </mat-menu>

  <app-table-header-column name="messages" alignRight="true" size="smallest">
    <span content>Comentários</span>
  </app-table-header-column>
</ng-container>
